/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDNavBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーナビゲーションボタン
 */
const setDNavBtn = () => {
	var body = document.body;
	var DNavBtn = document.getElementById("d-nav-btn");
	var DNav = document.getElementById("site-h_d-nav");
	var DNavLinks = DNav ? DNav.querySelectorAll("a") : null;

	// 要素が存在する場合のみイベントリスナーを追加
	if (DNavBtn && DNav) {
		// ドロワーナビボタンのクリックイベント
		DNavBtn.addEventListener("click", function () {
			body.classList.toggle("open");
			DNavBtn.classList.toggle("open");
			DNav.classList.toggle("open");
		});

		// ナビゲーションの外側をクリックした時の処理
		document.addEventListener("click", function (event) {
			// ナビゲーションが開いている場合のみ処理
			if (DNav.classList.contains("open")) {
				// クリックされた要素がナビゲーション内またはボタン内でない場合
				if (!DNav.contains(event.target) && !DNavBtn.contains(event.target)) {
					body.classList.remove("open");
					DNavBtn.classList.remove("open");
					DNav.classList.remove("open");
				}
			}
		});

		// ドロワーナビ内のリンククリックでメニューを閉じる
		if (DNavLinks && DNavLinks.length) {
			DNavLinks.forEach((link) => {
				link.addEventListener("click", () => {
					if (DNav.classList.contains("open")) {
						body.classList.remove("open");
						DNavBtn.classList.remove("open");
						DNav.classList.remove("open");
					}
				});
			});
		}
	}
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setDNavBtn };
